<template>
<v-layout row wrap justify-space-around>
  <v-flex xs5>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="elevation-4" color="primary" dark max-width="500px" style="border-radius: 12px;" >
        <v-card-text>
          <v-flex xs12 text-xs-center>
            {{loadText}}...
          </v-flex>
          <!-- <v-progress-linear indeterminate color="white" class="mb-0" ></v-progress-linear> -->
          <v-flex xs12 class="mt-2">
            <v-icon large class="moveball theball mdi-spin mdi-48px" color="white">mdi-soccer</v-icon>

            <!-- <v-progress-circular :size="70" :width="7" color="white" indeterminate></v-progress-circular> -->
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-flex>
</v-layout>
</template>

<script>
  export default {
    name: 'cardLoading',
    props: {
      loadText: {
        type: String,
        default: () => 'Carregando'
      },
    },
    data() {
      return {
        dialog: true
      }
    },
  }
</script>

<style scoped>
.v-dialog {
  border-radius: 45px !important;
}

.theball{
  position: relative;
  /* transition: all 1s ease-in-out; */
  /*-moz-animation: myfootie 2s infinite; /* Firefox */
  -webkit-animation: myfootie 2s infinite; /* Safari 4.0 - 8.0 */
  animation: myfootie 2s infinite;
  /*-webkit-transition: all 1s ease-in-out; /** Chrome & Safari **/
  /*-moz-transition: all 1s ease-in-out; /** Firefox **/
  /*-o-transition: all 1s ease-in-out; /** Opera **/
}

/* Safari 4.0 - 8.0 */
@-webkit-keyframes myfootie {
  0%   {left: 0px;}
  50%  {left: 85%}
  100% {left: 0px}
}

@keyframes myfootie {
  0%   {left: 0px;}
  50%  {left: 85%}
  100% {left: 0px}
}

</style>